
import { mapState, mapGetters } from 'vuex'
import modalWrapper from '@/mixins/modalWrapper'

export default {
    mixins: [modalWrapper],
    props: {
        model: {
            type: Object,
            default: () => {
                return {}
            },
        },
        content: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    data() {
        return {
            loading: false,
            currentEvent: undefined,
        }
    },

    computed: {
        ...mapGetters({
            smDevice: 'data/smDevice',
            events: 'user/events',
        }),

        ...mapState({
            user: (state) => state.auth?.user || {},
        }),

        disabled() {
            return !this.currentEvent || !this.currentEvent.id
        },

        email() {
            return this.model.metas?.contact_email
        },

        title() {
            return this.content?.title?.replace('%name%', this.model.name) || 'Message Vendor'
        },

        computedEvents() {
            return [...(this.events || []), { name: 'Create New Event', id: -1 }]
        },
    },

    watch: {
        isOpen: {
            handler(isOpen) {
                if (isOpen && (!this.events || !this.events.length)) {
                    this.$store.dispatch('user/getEvents')
                }
            },
            immediate: true,
        },
    },

    methods: {
        async sendForm(event) {
            try {
                this.loading = true
                await this.$store.dispatch('message/send', {
                    email: this.email,
                    event: 'vendor-message',
                    params: {
                        vendor: this.model.name,
                        sender_firstname: this.user.firstname,
                        sender_lastname: this.user.lastname,
                        sender_email: this.user.email,
                        event_name: event.name,
                        event_date: event.date,
                        event_location: event.location,
                        event_guest_count: event.guest_count,
                    },
                    toastMessage: 'The message is successfully sent',
                })
                this.cancel()
            } finally {
                this.loading = false
            }
        },

        setEvent(event) {
            this.currentEvent = event.id ? event : {}
        },
        cancel() {
            this.currentEvent = undefined
            this.close
        },
    },
}
